
// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { toast } from 'react-toastify';

// const Logout = () => {
//   const navigate = useNavigate();
//   const [isLoggingOut, setIsLoggingOut] = useState(true);

//   const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

//   useEffect(() => {
//     const performLogout = async () => {
//       setIsLoggingOut(true);

//       // Get session ID from localStorage
//       const sessionId = localStorage.getItem('sessionId');

//       // If we have a session ID, invalidate it on the server
//       if (sessionId) {
//         try {
//           const response = await axios.post(`${baseUrl}/api/users/logout`, {
//             sessionId
//           }, {
//             withCredentials: true
//           });

//           if (response.data.success) {
//             console.log('✅ Session invalidated on server');
//             // toast.success('Logged out successfully');
//           } else {
//             console.warn('⚠️ Logout response not successful:', response.data.message);
//             toast.info('Logged out locally');
//           }
//         } catch (error) {
//           console.error('❌ Error calling logout API:', error);
//           // Don't show error toast - we still want to log out locally
//           toast.info('Logged out');
//         }
//       }

//       // Clear all authentication data from localStorage
//       localStorage.removeItem('authToken');
//       localStorage.removeItem('sessionId');
//       localStorage.removeItem('tenantid');
//       localStorage.removeItem('ownerid');
//       localStorage.removeItem('username');
//       localStorage.removeItem('role');
//       localStorage.removeItem('me');
//       localStorage.removeItem('user');

//       // Clear window global if it exists
//       if (window.__ME__) {
//         delete window.__ME__;
//       }

//       // Small delay to show logout message, then redirect
//       setTimeout(() => {
//         setIsLoggingOut(false);
//         navigate('/login', { replace: true });
//       }, 500);
//     };

//     performLogout();
//   }, [navigate, baseUrl]);

//   return (
//     <div className="container text-center" style={{ marginTop: '50px' }}>
//       <div className="card" style={{ maxWidth: '400px', margin: '0 auto' }}>
//         <div className="card-body">
//           {isLoggingOut ? (
//             <>
//               <h4 className="hdr hdr--primary hdr--lg">Logging out...</h4>
//               <p>Please wait while we log you out.</p>
//               <div className="spinner-border text-primary mt-3" role="status">
//                 <span className="sr-only">Loading...</span>
//               </div>
//             </>
//           ) : (
//             <>
//               <h4 className="hdr hdr--primary hdr--lg">Logged Out</h4>
//               <p>Redirecting to login...</p>
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Logout;


import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const Logout = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(true);

  const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

  useEffect(() => {
    const performLogout = async () => {
      setIsLoggingOut(true);

      // Get session ID from localStorage
      const sessionId = localStorage.getItem('sessionId');
      
      console.log('🔍 Logout - SessionId from localStorage:', sessionId);

      // If we have a session ID, invalidate it on the server
      if (sessionId) {
        try {
          console.log('📤 Sending logout request to:', `${baseUrl}/api/users/logout`);
          
          const response = await axios.post(`${baseUrl}/api/users/logout`, {
            sessionId: sessionId
            // hardDelete: true  // ⚠️ UNCOMMENT THIS IF YOU WANT TO PERMANENTLY DELETE THE SESSION
          }, {
            withCredentials: true
          });

          console.log('📥 Logout response:', response.data);

          if (response.data.success) {
            console.log('✅ Session invalidated on server');
            toast.success(t('auth.logoutSuccessMessage'));
          } else {
            console.warn('⚠️ Logout response not successful:', response.data.message);
            toast.info(t('auth.logoutLocalMessage'));
          }
        } catch (error) {
          console.error('❌ Error calling logout API:', error);
          console.error('Error details:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status
          });
          
          // Show error but still log out locally
          toast.warning(t('auth.sessionCleanupWarning'));
        }
      } else {
        console.warn('⚠️ No session ID found in localStorage');
        toast.info(t('auth.noSessionFoundMessage'));
      }

      // 🧹 Clear all authentication data from localStorage
      console.log('🧹 Clearing localStorage...');
      localStorage.removeItem('authToken');
      localStorage.removeItem('sessionId');
      localStorage.removeItem('tenantid');
      localStorage.removeItem('ownerid');
      localStorage.removeItem('username');
      localStorage.removeItem('role');
      localStorage.removeItem('me');
      localStorage.removeItem('user');

      // Clear window global if it exists
      if (window.__ME__) {
        delete window.__ME__;
      }

      console.log('✅ localStorage cleared');

      // Small delay to show logout message, then redirect
      setTimeout(() => {
        setIsLoggingOut(false);
        console.log('➡️ Redirecting to login...');
        navigate('/login', { replace: true });
      }, 1000);
    };

    performLogout();
  }, [navigate, baseUrl]);

  return (
    <div className="container text-center" style={{ marginTop: '50px' }}>
      <div className="card" style={{ maxWidth: '400px', margin: '0 auto' }}>
        <div className="card-body">
          {isLoggingOut ? (
            <>
              <h4 className="hdr hdr--primary hdr--lg">{t('auth.loggingOutTitle')}</h4>
              <p>{t('auth.logoutWaitMessage')}</p>
              <div className="spinner-border text-primary mt-3" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </>
          ) : (
            <>
              <h4 className="hdr hdr--primary hdr--lg">{t('auth.loggedOutTitle')}</h4>
              <p>{t('auth.redirectingMessage')}</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Logout;
